import React, { useContext } from 'react';
import PortalNav from '../header/portal_nav';
import Context from '../../../utils/context';

import { isPhoneCallsEnabled } from '../../../helpers/feature_checker.js';

import styles from './index.module.css';

const AdminHeader = () => {
  const context = useContext(Context);
  const currentUser = context.auth.getCurrentUser();
  const isMobile = context.viewport.getIsMobile();
  const isImpersonating = context.auth.isImpersonating();

  const isImpersonatingMentor = isImpersonating && currentUser.current_profile_type === 'PatientPartner';
  const phoneCallsEnabled = isPhoneCallsEnabled(context.auth.currentAccount());

  const menuItems = [
    ...(isImpersonatingMentor
      ? [
          {
            title: 'Conversations',
            props: { to: '/member/conversations' },
            icon: 'https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/newsfeed/icon+16/messages.svg',
          },
          ...(phoneCallsEnabled
            ? [
                {
                  title: 'My Calls',
                  props: { to: '/member/calls' },
                  icon: 'https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/icons/phone.svg',
                },
              ]
            : []),
        ]
      : []),
    {
      title: 'Settings',
      hr_top: true,
      props: {
        to: '/member/settings',
      },
    },
    {
      onclick: 'logout',
      title: 'Log out',
    },
  ];

  return (
    <header className='platform-header' id='hdr-content'>
      <div className='container-fluid'>
        <div className={`header-outr row align-items-center ${isMobile ? styles.mobileRow : ''}`}>
          <div className={isMobile ? styles.logoColMobile : 'col-2'}>
            <div className='hdr-logo'>
              <img
                alt='logo'
                id='logo'
                src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/logos/svg/pp-logo.svg'
              />
            </div>
          </div>

          <div className={isMobile ? styles.controlsColMobile : 'col-4 d-flex align-items-center justify-content-end'}>
            {/* The global ImpersonationBanner carries all super user session controls. */}
            <div className={styles.portalNavWrapper}>
              <PortalNav navigationItems={menuItems} />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
